import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { fetchTodayDate } from 'src/app/core/helpers/fetchTodayDate.helper';

@Component({
  selector: 'megastore-admin-expected-delivery-date',
  templateUrl: './expected-delivery-date.component.html',
  styleUrls: ['./expected-delivery-date.component.scss']
})
export class ExpectedDeliveryDateComponent {
  submitted = false;
  showError = false;
  expectedDeliveyDateForm: FormGroup;
  deliveryDate = '';
  constructor(
    private dialogRef: MatDialogRef<ExpectedDeliveryDateComponent>,
    private formBuilder: FormBuilder
  ) {
    this.expectedDeliveyDateForm = this.formBuilder.group({
      expectedDate: ['', Validators.required]
    });
  }
  currentDate = fetchTodayDate;
  closeDialog(): void {
    this.dialogRef.close(null);
  }

  onSubmit(): void {
    this.submitted = true;
    this.dialogRef.close(
      this.expectedDeliveyDateForm.get('expectedDate')?.value
    );
  }
}
